import { render } from "./Semesters.vue?vue&type=template&id=48c5ac9e"
import script from "./Semesters.vue?vue&type=script&lang=js"
export * from "./Semesters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__